export enum ConnectionState {
    Connecting = "CONNECTING",
    Connected = "CONNECTED",
    Reconnecting = "RECONNECTING",
    Disconnected = "DISCONNECTED"
}
